export { default } from './AccountDetailsFlyout';
